import { useEffect } from "react";

export default function ReactPageFallthrough() {
  useEffect(() => {
    location.reload();
  }, []);
}
